"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateCustomFieldAction = exports.reducer = exports.getOrderedCustomFields = exports.getIsLoadingCustomFields = exports.getCustomFieldEntitiesMap = exports.fetchIssueCustomFieldsAction = exports.deleteIssueCustomFieldsAction = exports.STATE_KEY = void 0;
var _map = _interopRequireDefault(require("lodash/map"));
var _toolkit = require("@reduxjs/toolkit");
var _fetchHelpers = require("../fetchHelpers");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const initialState = {
  [_fetchHelpers.STATUS_KEY]: _fetchHelpers.FetchStatus.Initial,
  entitiesMap: {},
  issueCustomFieldIds: [],
  pendingUpdatesMap: {}
};
const issueCustomFieldsSlice = (0, _toolkit.createSlice)({
  name: "issueCustomFields",
  initialState,
  reducers: {
    issueCustomFieldsFetchStart(state) {
      state[_fetchHelpers.STATUS_KEY] = _fetchHelpers.FetchStatus.Loading;
    },
    issueCustomFieldsFetchSuccess(state, action) {
      state[_fetchHelpers.STATUS_KEY] = _fetchHelpers.FetchStatus.Success;
      state.issueCustomFieldIds = (0, _map.default)(action.payload, "id");
      state.entitiesMap = action.payload.reduce((acc, item) => {
        acc[item.id] = item;
        return acc;
      }, {});
      state.pendingUpdatesMap = {};
    },
    issueCustomFieldUpdateByIdStart(state, action) {
      state.pendingUpdatesMap[action.payload.id] = action.payload.entityChanges;
    },
    issueCustomFieldUpdateByIdFailure(state, action) {
      delete state.pendingUpdatesMap[action.payload.id];
    }
  }
});
const {
  issueCustomFieldsFetchStart,
  issueCustomFieldsFetchSuccess,
  issueCustomFieldUpdateByIdStart,
  issueCustomFieldUpdateByIdFailure
} = issueCustomFieldsSlice.actions;
const fetchIssueCustomFieldsAction = () => (dispatch, getState, _ref) => {
  let {
    sdk
  } = _ref;
  dispatch(issueCustomFieldsFetchStart());
  sdk.IssueCustomFields.getAll().then(payload => {
    dispatch(issueCustomFieldsFetchSuccess(payload.results));
  });
};
exports.fetchIssueCustomFieldsAction = fetchIssueCustomFieldsAction;
const updateCustomFieldAction = _ref2 => {
  let {
    id,
    entityChanges,
    onSuccess,
    onFailure
  } = _ref2;
  return async (dispatch, getState, _ref3) => {
    let {
      sdk
    } = _ref3;
    dispatch(issueCustomFieldUpdateByIdStart({
      id,
      entityChanges
    }));
    try {
      const fieldAfterChanges = await sdk.IssueCustomFields.update(id, entityChanges);
      onSuccess && onSuccess(fieldAfterChanges);
    } catch (error) {
      dispatch(issueCustomFieldUpdateByIdFailure({
        id
      }));
      onFailure && onFailure(error);
      return;
    }
    dispatch(fetchIssueCustomFieldsAction());
  };
};
exports.updateCustomFieldAction = updateCustomFieldAction;
const deleteIssueCustomFieldsAction = _ref4 => {
  let {
    id,
    onSuccess,
    onFailure
  } = _ref4;
  return async (dispatch, getState, _ref5) => {
    let {
      sdk
    } = _ref5;
    try {
      await sdk.IssueCustomFields.delete(id);
      onSuccess && onSuccess();
    } catch (e) {
      onFailure && onFailure(e);
    }
    dispatch(fetchIssueCustomFieldsAction());
  };
};
exports.deleteIssueCustomFieldsAction = deleteIssueCustomFieldsAction;
const reducer = exports.reducer = issueCustomFieldsSlice.reducer;
const STATE_KEY = exports.STATE_KEY = issueCustomFieldsSlice.name;
const getIssueCustomFieldsState = state => {
  return state[STATE_KEY];
};
const getCustomFieldEntitiesMap = exports.getCustomFieldEntitiesMap = (0, _toolkit.createSelector)(getIssueCustomFieldsState, state => Object.entries(state.pendingUpdatesMap).reduce((entitiesMap, _ref6) => {
  let [id, updates] = _ref6;
  // @ts-ignore because it might be a different type (it won't)
  entitiesMap[id] = {
    ...entitiesMap[id],
    ...updates
  };
  return entitiesMap;
}, {
  ...state.entitiesMap
}));
const getOrderedCustomFields = exports.getOrderedCustomFields = (0, _toolkit.createSelector)(getIssueCustomFieldsState, getCustomFieldEntitiesMap, (state, entitiesMap) => state.issueCustomFieldIds.map(id => entitiesMap[id]));
const getIsLoadingCustomFields = exports.getIsLoadingCustomFields = (0, _toolkit.createSelector)(getIssueCustomFieldsState, _fetchHelpers.isLoading);
//# sourceMappingURL=issueCustomFields.js.map